<style lang='less' scoped>
@import '../base.less';
</style>
<template>
  <div>
    <!-- SEARCH -->
    <!--    -->
    <Row>
      <Col span='24'>
        <Card style="margin-bottom: 10px;position: relative;">
          <span slot="title">人工提现</span>
          <Form ref="windowChangeForm" :rules="windowChangeValidate" :model="windowChangeItem" :label-width="200"
                label-position="left">
            <FormItem label='提现账号' prop='username'>
              <Input clearable v-model='windowChangeItem.username' :placeholder="$t('请输入提现账号')"
                     style="width: 160px"></Input>
            </FormItem>
<!--            <FormItem label='帐号类型' prop='user_type'>-->
<!--              <RadioGroup v-model="windowChangeItem.user_type">-->
<!--                <Radio :label="'0'">{{ $t('平台帐号') }}</Radio>-->
<!--                <Radio :label="'1'">{{ $t('测试帐号') }}</Radio>-->
<!--              </RadioGroup>-->
<!--            </FormItem>-->
            <FormItem label='提现金额' prop='rengong_withdraw'>
              <Input clearable :min='0' style="width: 160px" v-model='windowChangeItem.rengong_withdraw'
                     :placeholder="$t('请输入提现金额')"></Input>
            </FormItem>


            <FormItem label='提现类型' prop='withdraw_type'>
              <RadioGroup v-model="windowChangeItem.withdraw_type">
                <Radio label="0">{{ $t('人工提现') }}</Radio>
                <Radio label="1">{{ $t('人工提现(不计报表)') }}</Radio>
              </RadioGroup>

            </FormItem>
            <FormItem label='备注' prop='remark'>
              <Input type="textarea" style="width: 300px" v-model='windowChangeItem.remark'
                     :placeholder="$t('请输入备注')"></Input>
            </FormItem>
            <FormItem label="">
              <Button icon='md-backspace' type="warning" @click="windowChangeCancel()" class="margin-right-10">
                {{ $t('取消') }}
              </Button>
              <Button style="margin-right: 8px" icon='ios-checkmark-circle' type="primary" @click="windowChangeSubmit"
                      :loading="windowChange.loading">{{ $t('确定') }}
              </Button>
            </FormItem>
          </Form>

        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowChange.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowChangeCancel">

    </Modal>
    <Modal v-model="windowTip.show" width="668" :styles="{top: '30px'}" @on-visible-change="windowTipCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowTipItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowTipForm" :rules="windowTipValidate" :model="windowTipItem" :label-width="80"
            label-position="left">
        <FormItem label='备注' prop='remark'>
          <Input clearable v-model='windowTipItem.remark' :placeholder="$t('请输入备注')"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowTipCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowTipSubmit" :loading="windowTip.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/financeManage/withdrawRengong'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'

export default {
  name: 'interface_list',
  data () {
    return {
      timeOptions: {
        shortcuts: [{
          text: '今天',
          value () {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value () {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value () {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value () {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: { searchTime: [], }, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowChange: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowChangeItem: { //弹窗数据绑定
        id: 0,
        dama: 100,
        user_type: '0',
        withdraw_type: '0',
        username:''
      },
      windowChangeValidate: {//窗口校验规则
        username: [{
          required: true,
          message: '请输入提现账号',
          trigger: 'blur'
        }],

      }, windowTip: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowTipItem: { //弹窗数据绑定
        id: 0
      },
      windowTipValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created () {
    let vm = this
    this.windowChangeItem.username = this.$route.params.username ? this.$route.params.username : ''
  },
  mounted () {
    this.getParams()
  },
  methods: {
    preAdd () {
      let vm = this
      vm.windowAdd.show = true
    },
    getParams () {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage (page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize (size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search () {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList () {

    },

    timeChange (datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({ column, key, order }) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowChangeCancel (data) {
      if (!data) {
        this.windowChangeItem.id = 0
        this.$refs['windowChangeForm'].resetFields()
        this.windowChange.show = false
        this.windowChange.loading = false
        this.windowChange.index = 0
      }
    }, windowChangeSubmit () {
      let vm = this
      vm.$refs['windowChangeForm'].validate((valid) => {
        if (valid) {
          vm.windowChange.loading = true
          add(vm.windowChangeItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.windowChangeCancel()
          }).catch(() => {
            vm.windowChange.loading = false
          })
        }
      })
    }, windowTipCancel (data) {
      if (!data) {
        this.windowTipItem.id = 0
        this.$refs['windowTipForm'].resetFields()
        this.windowTip.show = false
        this.windowTip.loading = false
        this.windowTip.index = 0
      }
    }, windowTipSubmit () {
      let vm = this
      vm.$refs['windowTipForm'].validate((valid) => {
        if (valid) {
          vm.windowTip.loading = true
          add(vm.windowTipItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowTipCancel()
          }).catch(() => {
            vm.windowTip.loading = false
          })
        }
      })
    },
  }
}
</script>
